import { FaCcVisa, FaCcMastercard, FaCcAmex, FaCcDiscover, FaApplePay, FaGooglePay } from "react-icons/fa";

const METHODS = [
  { Icon: FaCcVisa, name: "Visa", color: "#1A1F71" },
  { Icon: FaCcMastercard, name: "Mastercard", color: "#EB001B" },
  { Icon: FaCcAmex, name: "Amex", color: "#2E77BC" },
  { Icon: FaCcDiscover, name: "Discover", color: "#E8791C" },
  { Icon: FaApplePay, name: "Apple Pay", color: "#000000" },
  { Icon: FaGooglePay, name: "Google Pay", color: "#3C4043" },
];

export default function AcceptedPayments() {
  return (
    <div data-testid="accepted-payments">
      <div className="text-[10px] uppercase tracking-[0.3em] font-bold mb-3 text-zinc-500">
        Accepted Payments
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2.5">
        {METHODS.map(({ Icon, name, color }) => (
          <span
            key={name}
            className="inline-flex items-center gap-1.5"
            data-testid={`payment-${name.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <Icon size={26} style={{ color }} aria-hidden />
            <span className="text-[11px] font-semibold text-zinc-600 whitespace-nowrap">{name}</span>
          </span>
        ))}
      </div>
      <div className="text-[10px] text-zinc-400 mt-2.5">
        Secured by Stripe. Wallet options appear based on your device.
      </div>
    </div>
  );
}
